// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1kate","empty":"ModalGraph_empty__yFRB-"};